var render = function render(){var _vm=this,_c=_vm._self._c;return _c('statistiche-cliccatore-component',{attrs:{"idCliccatore":null,"hideGuide":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }